import { FC, useEffect, useRef } from "react";
import style from "./style.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX } from "@fortawesome/free-solid-svg-icons";
import useTheme from "../../context/Theme/useTheme";
interface props {
  response: ResponseResult;
  onClose: () => void;
}
const Snackbar: FC<props> = ({ response, onClose }) => {
  const theme = useTheme();
  const snackbar = useRef<HTMLDivElement>(null);
  const autoDismissTimer = useRef<NodeJS.Timeout | null>(null);
  
  let color = theme.palette.success;
  if (response.status >= 300 && response.status < 400) {
    color = theme.palette.warning;
  } else if (response.status >= 400) {
    color = theme.palette.error;
  }

  // Auto-dismiss functionality
  useEffect(() => {
    if (response.message) {
      // Clear any existing timer
      if (autoDismissTimer.current) {
        clearTimeout(autoDismissTimer.current);
      }

      // Show the snackbar
      setTimeout(() => {
        if (snackbar.current) snackbar.current.style.opacity = "0.9";
      }, 0);

      // Set auto-dismiss timer based on message type
      let dismissTime = 4000; // Default 4 seconds
      
      if (response.status >= 200 && response.status < 300) {
        dismissTime = 2000; // Success messages: 3 seconds
      } else if (response.status >= 400) {
        dismissTime = 10000; // Error messages: 6 seconds (users need more time to read)
      } else if (response.status >= 300 && response.status < 400) {
        dismissTime = 3000; // Warning messages: 5 seconds
      }

      // Set CSS custom property for animation duration
      if (snackbar.current) {
        snackbar.current.style.setProperty('--dismiss-time', `${dismissTime}ms`);
      }

      autoDismissTimer.current = setTimeout(() => {
        onClose();
      }, dismissTime);
    }

    // Cleanup function to clear timer
    return () => {
      if (autoDismissTimer.current) {
        clearTimeout(autoDismissTimer.current);
      }
    };
  }, [response.message, response.status, onClose]);

  return (
    <>
      {response.message && (
        <div
          ref={snackbar}
          className={style.snackbar}
          style={{
            backgroundColor: theme.palette.paper,
            boxShadow: "0 2px 8px" + theme.palette.shadow,
            color: theme.palette.textPrimary,
          }}
        >
          <FontAwesomeIcon
            data-testid="close-icon"
            className={style.xIcon}
            icon={faX}
            cursor={"pointer"}
            onClick={() => {
              // Clear the auto-dismiss timer when manually closing
              if (autoDismissTimer.current) {
                clearTimeout(autoDismissTimer.current);
              }
              onClose();
            }}
          />
          <div className={style.message}>{response.message}</div>
          <div
            className={style.status}
            style={{ backgroundColor: color, color: theme.palette.textAction }}
          >
            {response.status}
          </div>
        </div>
      )}
    </>
  );
};
export default Snackbar;
